import { render, staticRenderFns } from "./UserMian.vue?vue&type=template&id=c8a996da&scoped=true"
import script from "./UserMian.vue?vue&type=script&lang=js"
export * from "./UserMian.vue?vue&type=script&lang=js"
import style0 from "./UserMian.vue?vue&type=style&index=0&id=c8a996da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8a996da",
  null
  
)

export default component.exports